import { Divider, Stack, Typography } from "@mui/material";
import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { InvestmentCaseContext } from "Components/Analyses/_Shared/InvestmentCaseContext";
import type { FamilyGoalResponseDto } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { forwardRef, useContext, useEffect, useState } from "react";
import { ChildrenGoalForm } from "./ChildrenGoalForm";
import { ChildrenManagement } from "./ChildrenManagement";

type Props = {
  readonly editGoal?: FamilyGoalResponseDto;
  readonly onClose: () => void;
};

export const ChildrenGoalPane = forwardRef<{}, Props>(({ onClose, editGoal }, childrenGoalFormRef) => {
  const { t } = useResource();
  const [clientId, setClientId] = useState<string>();

  const { readOnly: isAnalysisReadOnly } = useContext(AnalysisDetailContext);
  const { isInvestmentCaseLocked } = useContext(InvestmentCaseContext);
  const readOnly = isAnalysisReadOnly || isInvestmentCaseLocked;

  useEffect(() => {
    if (editGoal?.clientGuid) {
      setClientId(editGoal.clientGuid);
    }
  }, [editGoal]);

  return (
    <Stack spacing={Spacing.XL}>
      <Typography fontWeight={600} variant="body1" mb={Spacing.XL}>
        {t(Resources.AnalysisDetail.Goals.GoalType.Children)}
      </Typography>
      <ChildrenManagement
        editMode={!!editGoal}
        disabled={readOnly}
        selectedClientId={clientId}
        onSelect={(clientId) => setClientId(clientId)}
      />
      {clientId && (
        <>
          <Divider />
          <ChildrenGoalForm editGoal={editGoal} clientId={clientId} onClose={onClose} ref={childrenGoalFormRef} />
        </>
      )}
    </Stack>
  );
});
